import { FaLinkedin, FaPinterest, FaInstagram, FaFacebook, FaTwitter, FaBlog, FaEnvelope, FaNewspaper, FaMedium, FaYoutube } from 'react-icons/fa';

// Shared platform list + label localizer — used by the Settings "Kanäle" tab
// and the Brand-DNA preferences component (per-platform language). Extracted
// verbatim from Settings.js so both import ONE source (no duplicate).
export const PLATFORM_LANG_LIST = [
  { key: 'linkedin', label: 'LinkedIn', icon: FaLinkedin, color: '#0077B5' },
  { key: 'instagram', label: 'Instagram', icon: FaInstagram, color: '#E4405F' },
  { key: 'facebook', label: 'Facebook', icon: FaFacebook, color: '#1877F2' },
  { key: 'x', label: 'X', icon: FaTwitter, color: '#000000' },
  { key: 'pinterest', label: 'Pinterest', icon: FaPinterest, color: '#BD081C' },
  { key: 'blog', label: 'Blog', icon: FaBlog, color: '#00D9C8' },
  { key: 'newsletter', label: 'Newsletter', icon: FaEnvelope, color: '#F59E0B' },
  { key: 'medium', label: 'Medium', icon: FaMedium, color: '#A0AEC0' },
  { key: 'pressemitteilung', label: 'Press', icon: FaNewspaper, color: '#6B7280' },
  { key: 'youtube', label: 'YouTube', icon: FaYoutube, color: '#FF0000' },
];

// Localize platform label: arrays hold English defaults; German users see localized names
export const localizePlatformLabel = (item, lang) => {
  if (item?.key === 'pressemitteilung' && lang === 'de') return 'Presse';
  return item?.label;
};
